import React, { useEffect, useState } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import dayjs from 'dayjs';
import './index.css';
import CalendarSolid from './../../../../assets/svg/calendar-solid.svg';
import CalendarSolidActive from './../../../../assets/svg/calendar-solid-active.svg';
import ListSolid from './../../../../assets/svg/list-solid.svg';
import ListSolidActive from './../../../../assets/svg/list-solid-active.svg';
import { dateFormate } from '@constants/index';

function EventFilters({
  typeFilters,
  selectedType,
  filterSessionData,
  calendarDate,
  view,
  setView,
  Views,
}: any) {
  const [selectedMonth, setSelectedMonth] = useState<any>(
    dayjs().format(dateFormate.yyyy_mm_dd),
  );

  useEffect(() => {
    setSelectedMonth(dayjs(calendarDate).format(dateFormate.yyyy_mm_dd));
  }, [calendarDate]);

  return (
    <>
      <div className="filterOuterDiv">
        <div style={{ padding: 12 }}>
          <span style={{ color: '#797979' }}>FILTERS</span>
          <div style={{ float: 'right', display: 'flex' }}>
            <div
              style={{ marginRight: 5 }}
              data-testid="month-view-container"
              className="filterCalendar"
              onClick={() => {
                setView(Views.MONTH);
              }}
            >
              {view == Views.MONTH ? (
                <CalendarSolidActive />
              ) : (
                <CalendarSolid />
              )}
            </div>
            <div
              className='filterPipe'
            ></div>
            <div
              data-testid="agenda-view-container"
              className="filterCalendar"
              onClick={() => {
                setView(Views.AGENDA);
              }}
            >
              {view == Views.AGENDA ? <ListSolidActive /> : <ListSolid />}
            </div>
          </div>
        </div>
        <div className="filterLabelMainDiv">
          {typeFilters?.map((el: any, i: any) => (
            <div
              key={i}
              className={`filterLabel ${selectedType == el?.key ? 'selected' : ''}`}
              onClick={() => {
                filterSessionData({ date: selectedMonth, type: el?.key });
              }}
              style={{ background: el?.color, borderColor: el.color, color: el?.textColor }}
            >
              {el?.value}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default EventFilters;
